export default "__VITE_ASSET__b5eff293__"